import { useNavigate } from "react-router-dom";

import { ChalkActionButton, ChalkCard } from "../components/chalk/primitives";

export default function BillingCancelled() {
  const navigate = useNavigate();
  return (
    <div className="chalk-min-h-screen" style={{
      display: "flex", alignItems: "center", justifyContent: "center",
      background: "var(--chalk-cream, #FBF8F2)", padding: 24,
    }}>
      <ChalkCard data-testid="billing-cancelled-card" style={{ maxWidth: 420, width: "100%", textAlign: "center" }}>
        <div style={{ fontSize: 11, textTransform: "uppercase", letterSpacing: "0.08em", color: "var(--chalk-muted)" }}>
          No charge
        </div>
        <h1 style={{
          fontFamily: "var(--font-serif, 'DM Serif Display', serif)",
          fontSize: 26, color: "var(--chalk-board)", margin: "12px 0",
        }}>
          No worries. Your team is still here.
        </h1>
        <div style={{ fontSize: 14, color: "var(--chalk-muted)", marginBottom: 16 }}>
          Whenever you're ready to upgrade, the board's waiting.
        </div>
        <ChalkActionButton
          testId="billing-cancelled-back"
          variant="primary"
          label="Back to Chalk"
          onClick={() => navigate("/app", { replace: true })}
        />
      </ChalkCard>
    </div>
  );
}
